import config from "./config";

/** Features hidden from EN clients. Admin (testengv) still sees them. Rod lists more here. */
export const EN_HIDDEN_FOR_CLIENT = {
  superPromos: true,
};

export function showEnClient(feature, isAdmin) {
  if (config.STORE_LOCALE === "pt") return true;
  if (isAdmin) return true;
  return !EN_HIDDEN_FOR_CLIENT[feature];
}
